var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.15 0.55L17.54 2.23C17.83 2.57 18 3.02 18 3.5V16C18 17.1 17.1 18 16 18H2C0.9 18 0 17.1 0 16V3.5C0 3.02 0.17 2.57 0.46 2.23L1.84 0.55C2.12 0.21 2.53 0 3 0H15C15.47 0 15.88 0.21 16.15 0.55ZM14.76 2H3.24L2.44 2.97H15.57L14.76 2ZM2 16V5H16V16H2ZM7.55 7H10.45V10H13L9 14L5 10H7.55V7Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveHover);
export default __webpack_public_path__ + "static/media/archive-hover.5efbc25a71fb5df65061329a2166f418.svg";
export { ForwardRef as ReactComponent };